// Authentication type - string descriptions from AppLookups
export type AuthenticationType = string

// Predefined constants for known auth type descriptions
export const AUTH_TYPE = {
  UsernamePassword: 'Username/Password',
  GoogleSocial: 'Google Social',
  GoogleWorkspace: 'Google Workspace',
  Microsoft: 'Microsoft'
} as const

export interface GoogleWorkspaceCredentials {
  clientId: string
  clientSecret: string
  domain: string
  domainAliases?: string[]
}

/**
 * Microsoft Entra ID credentials.
 *
 * Not a renamed GoogleWorkspaceCredentials: Google takes a single `domain` that is both the
 * tenant identity and the email domain, while Microsoft splits them. `tenantDomain` is the Entra
 * tenant (contoso.onmicrosoft.com); `emailDomains` is what people actually sign in with
 * (contoso.com) and is what the connection matches a real user against. At least one email domain
 * is required — a connection carrying only a tenant domain matches nobody.
 */
export interface MicrosoftCredentials {
  clientId: string
  clientSecret: string
  tenantDomain: string
  emailDomains: string[]
}

export interface AddAuthConnectionRequest {
  type: string  // Auth type description string (e.g., "Google Social")
  googleWorkspace?: GoogleWorkspaceCredentials
  microsoft?: MicrosoftCredentials
}

export interface GoogleWorkspaceConfigDto {
  Domain: string
  DomainAliases?: string[]
  ConnectionName: string | null
}

export interface MicrosoftConfigDto {
  TenantDomain: string
  EmailDomains?: string[]
  ConnectionName: string | null
}

export interface AuthConnectionDto {
  Type: string  // Auth type description string from server
  ConnectionId: string | null
  IsEnabled: boolean
  ConfiguredAt: string | null
  GoogleWorkspace?: GoogleWorkspaceConfigDto
  Microsoft?: MicrosoftConfigDto
}

export interface UpdateAuthConnectionRequest {
  isEnabled?: boolean
}
